import { Col, Row } from "reactstrap";
import PrimaryButton from "../../../../../components/common/PrimaryButton/PrimaryButton";
import { useState } from "react";
import ChangePasswordModal from "./ChangePasswordModal/ChangePasswordModal";
import YellowHeaderWrapper from "../../../../../components/common/YellowHeaderWrapper/YellowHeaderWrapper";

const PasswordManagement = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div>
      <YellowHeaderWrapper title={"Password Management"}>
        <Row className="g-0 row-gap-1 align-items-center">
          <Col lg={3} xxl={2} className="pe-lg-2">Password:</Col>
          <Col lg={6} xxl={4}>**********</Col>
        </Row>

        <div>
          <PrimaryButton
            name={"Change Password"}
            onClick={() => setIsModalOpen(true)}
          />
        </div>

        <Row className="g-0 row-gap-1">
          <Col lg={3} xxl={2} className="pe-lg-2">Password Strength Indicator:</Col>
          <Col lg={6} xxl={4}>
            The password must be at least 8 characters long, include upper and
            lower case letters, numbers, and special characters. Avoid common
            words or phrases.
          </Col>
        </Row>
      </YellowHeaderWrapper>

      <ChangePasswordModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </div>
  );
};

export default PasswordManagement;